import { render, staticRenderFns } from "./LahanGisVerification.vue?vue&type=template&id=55b5a396"
import script from "./LahanGisVerification.vue?vue&type=script&lang=js"
export * from "./LahanGisVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports